import React, { useState } from 'react';
import { Box } from '@mui/material';

import { PropertyTypeSelector } from '../../../components/molecules/PropertyTypeSelector';
import { UnitCounter } from '../../../components/molecules/UnitCounter';

export const stepTitle = 'What kind of place are you listing?';
export const stepDescription = ''; // No description needed as per Figma

const PropertyTypeSelection: React.FC = () => {
  const [selectedType, setSelectedType] = useState<string | null>('house');
  const [bedrooms, setBedrooms] = useState(3);
  const [bathrooms, setBathrooms] = useState(2);

  return (
    <Box
      sx={{
        maxWidth: { xs: '100%', md: 1000 }, // Wider on desktop to accommodate 4 cards
        margin: '0 auto',
        padding: { xs: 2, md: 4 },
        width: '100%',
      }}
    >
      <PropertyTypeSelector
        selectedType={selectedType}
        onSelectType={setSelectedType}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 3, sm: 4 },
          mt: 5,
          justifyContent: 'center',
        }}
      >
        <UnitCounter
          label='Bedrooms'
          count={bedrooms}
          onIncrement={() => setBedrooms(c => c + 1)}
          onDecrement={() => setBedrooms(c => (c > 0 ? c - 1 : 0))}
        />
        <UnitCounter
          label='Bathrooms'
          count={bathrooms}
          onIncrement={() => setBathrooms(c => c + 1)}
          onDecrement={() => setBathrooms(c => (c > 0 ? c - 1 : 0))}
        />
      </Box>
    </Box>
  );
};

export default PropertyTypeSelection;
